export const fontFamily = {
    inter: "'Inter', sans-serif",
    sora: "'Sora', sans-serif"
}